import { render, staticRenderFns } from "./campaignReviewLaunch.vue?vue&type=template&id=b03151b2&"
import script from "./campaignReviewLaunch.vue?vue&type=script&lang=js&"
export * from "./campaignReviewLaunch.vue?vue&type=script&lang=js&"
import style0 from "./campaignReviewLaunch.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports